export const ALERT_ACTIONS = {
  CLOSE: 'close',
  CANCEL: 'cancel',
  CONFIRM: 'confirm',
} as const;

export type AlertAction = (typeof ALERT_ACTIONS)[keyof typeof ALERT_ACTIONS];
